import styled from 'styled-components';
import { SkeletonLine, SkeletonTextLine } from './skeletonLine';

/** Mirrors the icon-plus-content layout of dashboard/cardData. */
const DataRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5px;
  width: 100%;
  /* The pixel widths below are the design's, not a floor. Without this the row
     refuses to shrink under them and the card spills out of a narrow task pane. */
  min-width: 0;
`;

const ContentColumn = styled.div`
  flex: 1;
  min-width: 0;
`;

const SkeletonCardData = ({ withSubcontent = false }: { withSubcontent?: boolean }) => (
  <DataRow data-testid="skeleton-card-data">
    <SkeletonLine $width="18px" $height="18px" $radius="50%" />
    <ContentColumn>
      <SkeletonTextLine $lineheight="17px">
        <SkeletonLine $width="60px" $height="10px" />
      </SkeletonTextLine>
      <SkeletonTextLine $lineheight="18px">
        <SkeletonLine $width="200px" $height="12px" />
      </SkeletonTextLine>
      {withSubcontent && (
        <SkeletonTextLine $lineheight="20px" data-testid="skeleton-card-subcontent">
          <SkeletonLine $width="260px" $height="10px" />
        </SkeletonTextLine>
      )}
    </ContentColumn>
  </DataRow>
);

export default SkeletonCardData;
